module.exports = __webpack_public_path__ + "xls-lock.png?60a9910d9528cc90f24fc95088633a30";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/xls-lock.png
// module id = 39
// module chunks = 0